const headers = [
    {headerName: "Mark", field: "mark", filter: true, width: 100},
    {headerName: "Model", field: "model", filter: true, width: 100},
    {headerName: "Type", field: "type", filter: true, width: 100},
    {headerName: "Operation", field: "operation", filter: true, width: 100},
    {headerName: "Width", field: "width", filter: true, width: 100},
    {headerName: "Height", field: "height", filter: true, width: 100},
    {headerName: "Type", field: "type", filter: true, width: 100},
    {headerName: "DP-Ratings", field: "dpRating", filter: true, width: 100},
    {headerName: "U-Value", field: "uValue", filter: true, width: 100},
    {headerName: "Type", field: "type", filter: true, width: 100},
    {headerName: "STC", field: "stc", filter: true, width: 100},
    {headerName: "SHGC", field: "shgc", filter: true, width: 100},
    {headerName: "VT", field: "vt", filter: true, width: 100},
    {headerName: "Color", field: "color", filter: true, width: 100},
    {headerName: "Level", field: "level", filter: true, width: 100},
    {headerName: "QTY", field: "qty", filter: true, width: 100},
    {headerName: "Sub Total", field: "subTotal", filter: true, width: 100},
    {headerName: "Unit Price", field: "unitPrice", filter: true, width: 100},
    {headerName: "Sub Price", field: "subPrice", filter: true, width: 100},
    {headerName: "Glazing", field: "glazing", filter: true, width: 100},
    {headerName: "Glazing", field: "glazing", filter: true, width: 100},
    {headerName: "Glazing", field: "glazing", filter: true, width: 100},
    {headerName: "Status", field: "status", filter: true, width: 100},
    {headerName: "Actions", field: "actions", filter: true, width: 100},
    {
        headerName: "Requirements",
        field: "requirement",
        filter: true,
        width: 200,
        cellRenderer: 'viewBtnCellRenderer',
        cellRendererParams: {
            clicked: function (params) {
                alert(`${params} was clicked`);
            }
        },
    }
];

const data = [
    {
        mark: "Some Mark",
        model: "Some Model",
        type: "Some Type",
        operation: "Some Operation",
        width: "Width",
        height: "Height",
        dpRating: "DP Rating",
        uValue: "U Value",
        stc: "STC",
        shgc: "SHGC",
        vt: "VT",
        color: "Color",
        level: "Level",
        qty: "Qty",
        subTotal: "Sub Total",
        unitPrice: "Unit Price",
        subPrice: "Sub Price",
        glazing: "Glazing",
        status: "Status",
        actions: "Actions"
    },
    {
        mark: "Some Mark",
        model: "Some Model",
        type: "Some Type",
        operation: "Some Operation",
        width: "Width",
        height: "Height",
        dpRating: "DP Rating",
        uValue: "U Value",
        stc: "STC",
        shgc: "SHGC",
        vt: "VT",
        color: "Color",
        level: "Level",
        qty: "Qty",
        subTotal: "Sub Total",
        unitPrice: "Unit Price",
        subPrice: "Sub Price",
        glazing: "Glazing",
        status: "Status",
        actions: "Actions"
    },
    {
        mark: "Some Mark",
        model: "Some Model",
        type: "Some Type",
        operation: "Some Operation",
        width: "Width",
        height: "Height",
        dpRating: "DP Rating",
        uValue: "U Value",
        stc: "STC",
        shgc: "SHGC",
        vt: "VT",
        color: "Color",
        level: "Level",
        qty: "Qty",
        subTotal: "Sub Total",
        unitPrice: "Unit Price",
        subPrice: "Sub Price",
        glazing: "Glazing",
        status: "Status",
        actions: "Actions"
    },
    {
        mark: "Some Mark",
        model: "Some Model",
        type: "Some Type",
        operation: "Some Operation",
        width: "Width",
        height: "Height",
        dpRating: "DP Rating",
        uValue: "U Value",
        stc: "STC",
        shgc: "SHGC",
        vt: "VT",
        color: "Color",
        level: "Level",
        qty: "Qty",
        subTotal: "Sub Total",
        unitPrice: "Unit Price",
        subPrice: "Sub Price",
        glazing: "Glazing",
        status: "Status",
        actions: "Actions"
    },
    {
        mark: "Some Mark",
        model: "Some Model",
        type: "Some Type",
        operation: "Some Operation",
        width: "Width",
        height: "Height",
        dpRating: "DP Rating",
        uValue: "U Value",
        stc: "STC",
        shgc: "SHGC",
        vt: "VT",
        color: "Color",
        level: "Level",
        qty: "Qty",
        subTotal: "Sub Total",
        unitPrice: "Unit Price",
        subPrice: "Sub Price",
        glazing: "Glazing",
        status: "Status",
        actions: "Actions"
    }
];

const collaborators = [
    {
        name: "Collaborator Name",
        email: "collaboratoremail@mail.com",
        company: "Company Name",
        companyType: "Some Comapny Type"
    },
    {
        name: "Collaborator Name",
        email: "collaboratoremail@mail.com",
        company: "Company Name",
        companyType: "Some Comapny Type"
    },
    {
        name: "Collaborator Name",
        email: "collaboratoremail@mail.com",
        company: "Company Name",
        companyType: "Some Comapny Type"
    }
];
const scheduleItems = [
];
const selectedItems = [
];

const state = {
    headers,
    data,
    collaborators,
    viewModal: false,
    scheduleItems,
    selectedItems
};

const getters = {
    windowHeaders: state => state.headers,
    windowData: state => state.data,
    collaborators: state => state.collaborators,
    collaboratorsCount: state => state.collaborators.length
};

const mutations = {
    showModal(state) {
        state.viewModal = true;
    },
    hideModal(state) {
        state.viewModal = false;
    },
    changeSchedule(state,payload){
        state.scheduleItems=payload;
    },
    changeItem(state,payload){
        state.selectedItems=payload;
    }
};

const actions = {};

export default {
    state,
    getters,
    mutations,
    actions
};
